export default __webpack_public_path__ + "static/media/blue-hue.15284809.png";